import { LegalEntityFieldModel } from "../../entityTemplates/LegalEntityFieldRenderers";
import { LegalEntityAuditFrequency, LegalEntityAuditType } from "../LegalEntity.types";
import { CustomFieldValue } from "../../system/systemEdit/SystemEdit.types";

export class EditLegalEntityModel implements LegalEntityFieldModel {
    id: string = "";
    userFriendlyId: number = 0;
    entityTemplateId: string = "";
    name: string | undefined;
    description: string | undefined;
    referenceNumber: string | undefined;
    note: string | undefined;
    address: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    country: string | undefined;
    companyRegistrationNumber: string | undefined;
    website: string | undefined;
    types: Array<string> = [];
    isDataProcessorOnTransfers: boolean = false;
    isSubDataProcessorOnTransfers: boolean = false;
    isApproved: boolean = false;
    isActive: boolean = true;
    isCustomerOwned: boolean = false;
    responsibleId: string | null = null;
    businessAreaIds: Array<string> = [];
    complianceAreaIds: Array<string> = [];
    certificationIds: Array<string> = [];
    auditType: LegalEntityAuditType | undefined;
    auditFrequency: LegalEntityAuditFrequency | undefined;
    subContractorIds: Array<string> = [];
    shouldAutoAddSubContractors: boolean = false;
    customFieldValues: Array<CustomFieldValue> = [];
}

export interface EditLegalEntityUpdateModel {
    name: string | undefined;
    description: string | undefined;
    referenceNumber: string | undefined;
    note: string | undefined;
    address: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
    country: string | undefined;
    companyRegistrationNumber: string | undefined;
    website: string | undefined;
    types: Array<string>;
    isApproved: boolean;
    isActive: boolean;
    responsibleId: string | null | undefined;
    businessAreaIds: Array<string>;
    complianceAreaIds: Array<string>;
    certificationIds: Array<string>;
    auditType: LegalEntityAuditType | undefined;
    auditFrequency: LegalEntityAuditFrequency | undefined;
    shouldAutoAddSubContractors: boolean;
}
